




























































































































import { Component, Vue, Prop } from "vue-property-decorator";
import store from "@/store";
// @types
import { DiagnosticsChartConfig } from "@/types/DiagnosticsChartConfig";
// @modules
import { getModule } from "vuex-module-decorators";
import DiagnosticsModule from "@/store/clients/Diagnostics.module";
import SnackbarModule from "@/store/clients/Snackbar.module";

const Diagnostics = getModule(DiagnosticsModule, store);
const Snackbar = getModule(SnackbarModule, store);

@Component({})
export default class SpeedMeasurementIndicator extends Vue {
  @Prop({ required: false }) readonly vesselId!: number | null;
  // @Data
  isMenuOpen = false;
  loading = false;
  diagnosticsChartConfig: DiagnosticsChartConfig = {} as DiagnosticsChartConfig;
  useDerivedStw = false;
  speedMeasurementItems: { text: string; value: boolean }[] = [
    {
      text: "Speed Log",
      value: false,
    },
    {
      text: "Derived STW",
      value: true,
    },
  ];

  // @Getters
  get speedMeasurementSource(): string {
    return this.diagnosticsChartConfig.useDerivedStw ? "Derived STW" : "Speed Log";
  }
  get derivedStwHint(): string {
    return this.useDerivedStw
      ? "The derived Speed Through Water (STW) is calculated from the Speed Over Ground (SOG) and the ocean current’s speed and direction by resolving them into their components."
      : "";
  }

  // @Methods
  async fetchData(): Promise<void> {
    if (!this.vesselId) return;
    this.loading = true;
    try {
      this.diagnosticsChartConfig = await Diagnostics.fetchDiagnosticsChartConfig(this.vesselId);
      this.useDerivedStw = this.diagnosticsChartConfig.useDerivedStw;
    } catch (err) {
      this.diagnosticsChartConfig = {} as DiagnosticsChartConfig;
      this.useDerivedStw = false;
    } finally {
      this.loading = false;
    }
  }

  async update(): Promise<void> {
    try {
      this.diagnosticsChartConfig.useDerivedStw = this.useDerivedStw;
      await Diagnostics.updateDiagnosticsChartConfig(this.diagnosticsChartConfig);
      this.$emit("update");
      Snackbar.showSnackbar({ text: "Speed measurement source successfully updated", color: "ContentPrimaryStatic" });
    } catch (error) {
      Snackbar.showSnackbar({ text: "Failed to update speed measurement source" });
    }
  }

  // @Hooks
  async mounted(): Promise<void> {
    await this.fetchData();
  }
}
